/**
 * View component for /sentiment-questions/:sentimentQuestionId/update
 *
 * Updates a single sentimentQuestion from a copy of the selcted sentimentQuestion
 * as defined in the sentimentQuestion reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as sentimentQuestionActions from '../sentimentQuestionActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import SentimentQuestionForm from '../components/SentimentQuestionForm.js.jsx';
import SentimentQuestionLayout from '../components/SentimentQuestionLayout.js.jsx';

// import sentimentQuestion css modules
import sentimentQuestionStyles from '../sentimentQuestionModuleStyles.css';

class UpdateSentimentQuestion extends Base {
  constructor(props) {
    super(props);
    const { selectedSentimentQuestion, sentimentQuestionMap } = this.props;
    this.state = {
      sentimentQuestion: sentimentQuestionMap[selectedSentimentQuestion.id] ? { ...sentimentQuestionMap[selectedSentimentQuestion.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(sentimentQuestionActions.fetchSingleIfNeeded(match.params.sentimentQuestionId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedSentimentQuestion, sentimentQuestionMap } = nextProps;
    this.setState({
      sentimentQuestion: sentimentQuestionMap[selectedSentimentQuestion.id] ? { ...sentimentQuestionMap[selectedSentimentQuestion.id] } : {}
      //we don't want to actually change the store's sentimentQuestion, just use a copy
    })
  }

  _handleFormChange(e) {
    let newSentimentQuestionState = _.update( this.state.sentimentQuestion, e.target.name, function() {
      return e.target.value;
    });
    this.setState({sentimentQuestion :newSentimentQuestionState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(sentimentQuestionActions.sendUpdateSentimentQuestion(this.state.sentimentQuestion)).then((action) => {
      if(action.success) {
        history.push(`/admin/sentiment-questions/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedSentimentQuestion, sentimentQuestionMap } = this.props;
    const { sentimentQuestion } = this.state;
    const isEmpty = (!sentimentQuestion || sentimentQuestion._id === null || sentimentQuestion._id === undefined);
    return  (
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedSentimentQuestion.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <SentimentQuestionForm
                sentimentQuestion={sentimentQuestion}
                cancelLink={`/admin/sentiment-questions/${sentimentQuestion._id}`}
                formTitle="Update SentimentQuestion"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
    )
  }
}

UpdateSentimentQuestion.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedSentimentQuestion: store.sentimentQuestion.selected
    , sentimentQuestionMap: store.sentimentQuestion.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateSentimentQuestion)
);



// WEBPACK FOOTER //
// modules/sentimentQuestion/views/UpdateSentimentQuestion.js.jsx